/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CurrencyWithdrawalLimitResponse { 
    id: number;
    name: string;
    ticker: string;
    minWithdrawalAmount: number;
    oneTimeWithdrawalThreshold: number;
    dailyWithdrawalThreshold: number;
}

